export default __webpack_public_path__ + "static/thank-you-image-49a1ed05565769b90028c9f2aa7027ee.svg";